import React from "react";

interface props {
  children?: React.ReactNode;
  className?: string;
  heading?: string;
}
export const ImageAndTextCard = ({ children, className, heading }: props) => {
  return (
    <>
      <div className={`flex flex-col  ${className}`}>
        <p className="font-spaceGrotesk font-normal text-[10px] lg:text-[20px] leading-3 lg:leading-[25px] text-brand-bgBlack pt-[7px] pl-[10px]">
          {heading}
        </p>
        <div className="flex flex-grow justify-end">{children}</div>
      </div>
    </>
  );
};
export default ImageAndTextCard;
